import Input from '@/components/next-ui/Input';
import Typography from '@/components/next-ui/Typography';
import { yupResolver } from '@hookform/resolvers/yup';
import { cx } from 'cva';
import { isEmpty } from 'lodash-es';
import React, { useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { HiOutlineVideoCamera } from 'react-icons/hi';
import * as yup from 'yup';
import SelectedPostVideos from './SelectedPostVideos';
import ImageCarousel from '../ImageCarousel';

const fileSizeLimit = {
  size: 1024 * 1024 * 100, // 100MB
  message: 'File size should be less than 100MB',
};

const schema = yup.object().shape({
  publicVideoUrl: yup.string().url('Invalid URL format'),
});

function PostVideoSelector(props) {
  const { onChange, value = [] } = props;
  const [rejectedFiles, setRejectedFiles] = React.useState([]);

  const updateSelectedVideos = (videos) => {
    onChange(videos);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'video/*',
    multiple: true,
    maxSize: fileSizeLimit.size,
    maxFiles: 1,
    onDrop: (accepted, rejected) => {
      if (accepted.length > 0) {
        updateSelectedVideos(
          accepted.map((v) =>
            Object.assign(v, {
              url: URL.createObjectURL(v),
            }),
          ),
        );
      } else if (rejected.length > 0) {
        setRejectedFiles(rejected);
      }
    },
  });

  const isUrl = (string) => {
    // Regular expression pattern to check if the string is a URL
    const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return urlPattern.test(string);
  };

  const handleVideoLinkChange = (e) => {
    if (isUrl(e.target.value)) {
      onChange([{ url: e.target.value }]);
    } else {
      onChange([]);
    }
  };

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <div className="flex w-full flex-col items-stretch justify-start">
        <Input
          type="text"
          width="100%"
          placeholder="Provide a video link (youtube, vimeo, etc.)"
          onChange={handleVideoLinkChange}
        />
      </div>

      <div className="flex w-full items-center justify-center py-2">
        <Typography variant="h4" className="mt-4">
          OR
        </Typography>
      </div>

      <div
        className={cx(
          'flex w-full flex-col items-center justify-start rounded-md bg-primary-light-1 p-8',
          isDragActive && 'shadow-md',
        )}
        {...getRootProps()}>
        <input {...getInputProps()} name="imageFile" />
        <HiOutlineVideoCamera className="h-12 w-12 text-primary" />
        <Typography variant="h4" className="mt-4">
          Drop your files here or{' '}
          <span className="text-text-hyperlink">click</span> to select files
        </Typography>
      </div>
      {!isEmpty(value) && (
        <div className="mt-3 w-full">
          <ImageCarousel images={value} onChange={onChange} type="video" />
        </div>
      )}
    </div>
  );
}

export default PostVideoSelector;
